<template>
  <modal :show.sync="show" :on-close="onClose">
    <div class="h-auto overflow-auto mt-3 px-8 pb-2">
      <woot-modal-header> </woot-modal-header>
      <div
  class="custon_tab text-black-900"
  :class="{ 'bg-[#1F93FF] text-white': activeTab === 'import', 'bg-slate-200': activeTab !== 'import' }"
  @click="toggleElement('import')"
>
  {{ $t('IMPORT_CONTACTS.TITLE') }}
</div>
<div
  class="custon_tab text-black-900"
  :class="{ 'bg-[#1F93FF] text-white': activeTab === 'sync', 'bg-slate-200': activeTab !== 'sync' }"
  @click="toggleElement('sync')"
>
  {{ $t('Sync Fb Contact') }}
</div>

    </div>
    <div
      class="h-auto overflow-auto flex flex-col import_contact"
      v-show="showImport"
    >
      <div class="flex flex-col p-8 pt-0">
        <p>
          {{ $t('IMPORT_CONTACTS.DESC') }}
          <a :href="csvUrl" download="import-contacts-sample">{{
            $t('IMPORT_CONTACTS.DOWNLOAD_LABEL')
          }}</a>
        </p>
        <div class="w-full">
          <label>
            <span class="flex items-center gap-1">
              {{ $t('IMPORT_CONTACTS.FORM.LABEL') }} <span class="text-red-500"> *</span>
              <span class="info-icon-wrapper">
                <fluent-icon
                  icon="info"
                  size="14"
                  v-tooltip.right="$t('IMPORT_CONTACTS.FORM.PHONE_INFO')"
                  class="info-icon cursor-pointer text-slate-500 hover:text-slate-700"
                />
              </span>
            </span>
            <input
              id="file"
              ref="file"
              type="file"
              accept="text/csv"
              @change="handleFileUpload"
            />
          </label>
        </div>
        <div class="flex gap-3 items-center">
  <input type="checkbox" id="assignCheckbox" v-model="inboxDropdownEnabled" />
  <label for="assignCheckbox" class="assign-title cursor-pointer">
    Assign Inbox, Agents and Macros
  </label>
</div>
        <div class="flex gap-3 items-center">
  <input type="checkbox" id="boardPipelineCheckbox" v-model="boardPipelineEnabled" />
  <label for="boardPipelineCheckbox" class="assign-title cursor-pointer">
    Assign Board & Pipeline
  </label>
</div>
        <select v-if="inboxDropdownEnabled" v-model="selectedInbox" @change="fetchAttachedAgents">
          <option disabled value="">Select Inbox</option>
          <option v-for="inbox in inboxes" :key="inbox.id" :value="inbox.id">{{ inbox.name }}</option>
        </select>
        <multiselect
          v-if="inboxDropdownEnabled"
          v-model="selectedAgents"
          :options="selectedAgent"
          track-by="id"
          label="name"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :hide-selected="true"
          placeholder="Pick agents"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
        />
        <div @click="handleMacroClick" v-if="inboxDropdownEnabled">
          <multiselect
            v-model="selectedMacro"
            :options="macros"
            track-by="id"
            label="name"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            placeholder="Select Macro"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            :disabled="!selectedInbox"
            class="pointer-events-auto"
          />
        </div>

        <multiselect
          v-if="inboxDropdownEnabled"
          v-model="selectedLabels"
          :options="labels"
          track-by="id"
          label="title"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :hide-selected="true"
          placeholder="Select Labels"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
          
        />
        <select v-if="boardPipelineEnabled" v-model="selectedBoard" @change="fetchPipelineStatuses">
          <option disabled value="">Select Board</option>
          <option v-for="board in boards" :key="board.id" :value="board.id">{{ board.name }}</option>
        </select>
        <select v-if="boardPipelineEnabled && selectedBoard" v-model="selectedPipelineStatus">
          <option disabled value="">Select Pipeline Status</option>
          <option v-for="status in pipelineStatuses" :key="status.id" :value="status.id">{{ status.name }}</option>
        </select>
        <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
          <div class="w-full">
            <woot-button
              :disabled="uiFlags.isCreating || !file"
              :loading="uiFlags.isCreating"
              @click="uploadFile"
              class="data-change"
            >
              {{ $t('IMPORT_CONTACTS.FORM.SUBMIT') }}
            </woot-button>
            <button class="button clear" @click.prevent="onClose">
              {{ $t('IMPORT_CONTACTS.FORM.CANCEL') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-auto overflow-auto flex flex-col sync_contact"
      v-show="showSync"
    >
      <div class="flex flex-col pt-0 pb-8 pl-8 pr-8">
        <p>
          Sync Facebook lead to contact
        </p>
        <div class="w-[320px] h-[80px]">
          <label>
            <span> <p>Select Date</p></span>

            <div class="date-picker">
              <date-picker
                :range="true"
                :confirm="true"
                :clearable="false"
                :editable="false"
                :confirm-text="confirmText"
                :placeholder="placeholder"
                :value="value"
                @change="handleChange"
                v-model="selectedDate"
                :get-class="highlightToday"
                :disabled-date="disableFutureDates"
              />
            </div>
          </label>
        </div>
        <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
          <div class="w-full">
            <woot-button class="data-change" @click="sync_contact">
              Submit
            </woot-button>
            <button class="button clear" @click.prevent="onClose">
              {{ $t('IMPORT_CONTACTS.FORM.CANCEL') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../../../components/Modal';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { CONTACTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import DatePicker from 'vue2-datepicker';
import axios from 'axios';

if (DatePicker?.CalendarRange?.methods?.updateCalendars) {
  const originalUpdate = DatePicker.CalendarRange.methods.updateCalendars;

  DatePicker.CalendarRange.methods.updateCalendars = function(...args) {
    originalUpdate.apply(this, args);

    if (args.length === 1) {
      this.calendars = this.calendars.map(v => {
        const prev = new Date(v);
        prev.setMonth(prev.getMonth() - 1);
        return prev;
      });
    }
  };
}


export default {
  components: {
    Modal,
    DatePicker,
  },
  mixins: [alertMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    confirmText: {
      type: String,
      default: 'Select Date Range',
    },
    placeholder: {
      type: String,
      default: 'Select date range',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: true,
      file: '',
      showImport: true,
      activeTab: 'import', 
      showSync: false,
      selectedDate: null,
      selectedInbox: '',
      inboxDropdownEnabled: false,
      selectedAgents: [],
      selectedAgent: [],
      selectedMacro: null,
      selectedLabels: [],
      boardPipelineEnabled: false,
      selectedBoard: '',
      selectedPipelineStatus: '',
      boards: [],
      pipelineStatuses: [],
    };
  },
  watch: {
    inboxDropdownEnabled(enabled) {
      if (!enabled) {
        this.selectedInbox = '';
        this.selectedAgents = [];
        this.selectedAgent = [];
        this.selectedMacro = null;
        this.selectedLabels = [];
      }
    },
    boardPipelineEnabled(enabled) {
      if (!enabled) {
        this.selectedBoard = '';
        this.selectedPipelineStatus = '';
        this.pipelineStatuses = [];
      }
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
      inboxes: 'inboxes/getInboxes',
      macros: 'macros/getMacros',
      labels: 'labels/getLabels'
    }),
    csvUrl() {
      return '/downloads/import-contacts-sample.csv';
    },
  },
  mounted() {
    this.$track(CONTACTS_EVENTS.IMPORT_MODAL_OPEN);
    this.$store.dispatch("macros/get");
    this.fetchBoards();
  },
  methods: {
    async uploadFile() {
      try {
        if (!this.file) return;
        const payload = {
          file: this.file,
        };
        if (this.inboxDropdownEnabled) {
          payload.inboxId = this.selectedInbox;
          payload.agentList = this.selectedAgents.map(x => x.id);
          payload.macroId = this.selectedMacro?.id || null;
          payload.label_list = this.selectedLabels.map(label => label.id);
        }
        if (this.boardPipelineEnabled) {
          payload.statusId = this.selectedPipelineStatus;
          payload.boardId = this.selectedBoard;
        }
        const response = await this.$store.dispatch('contacts/import', payload);
        this.onClose();
        if(response.message){
          this.showAlert(this.$t(response.message));
        }
        else{
          this.showAlert(this.$t('IMPORT_CONTACTS.SUCCESS_MESSAGE'));
        }
        this.$track(CONTACTS_EVENTS.IMPORT_SUCCESS);
      } catch (error) {
        this.showAlert(
          error.message || this.$t('IMPORT_CONTACTS.ERROR_MESSAGE')
        );
        this.$track(CONTACTS_EVENTS.IMPORT_FAILURE);
      }
    },  
    async fetchAttachedAgents() {
      try {
        const response = await this.$store.dispatch('inboxMembers/get', {
          inboxId: this.selectedInbox,
        });
        this.selectedAgents = [];
        const {
          data: { payload: inboxMembers },
        } = response;
        this.selectedAgent = inboxMembers;
      } catch (error) {
        //  Handle error
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    toggleElement(element) {
      this.activeTab = element;
      if (element === 'import') {
        this.showImport = true;
        this.showSync = false;
      } else if (element === 'sync') {
        this.showSync = true;
        this.showImport = false;
      }
    },
    handleChange(value) {
      this.$emit('change', value);
    },
    /**
     * Facebook lead sync: full calendar days in the browser's local timezone.
     * Same calendar day → start 00:00:00, end 23:59:59 that day.
     * Multiple days → start 00:00:00 on first day, end 23:59:59 on last day.
     */
    fbLeadSyncDateTimeRangeFromPicker(range) {
      const [rawStart, rawEnd] = range;
      let start = new Date(rawStart);
      let end = new Date(rawEnd);
      const dayKey = d =>
        d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
      if (dayKey(end) < dayKey(start)) {
        [start, end] = [end, start];
      }
      const startNorm = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate(),
        0,
        0,
        0,
        0
      );
      const endNorm = new Date(
        end.getFullYear(),
        end.getMonth(),
        end.getDate(),
        23,
        59,
        59,
        0
      );
      const pad = n => String(n).padStart(2, '0');
      const fmt = d =>
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
          d.getHours()
        )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      return [fmt(startNorm), fmt(endNorm)];
    },
    async sync_contact() {
      const apiAccessToken = this.currentUser.access_token;
      if (!this.selectedDate || !Array.isArray(this.selectedDate) || this.selectedDate.length !== 2 || !this.selectedDate[0] || !this.selectedDate[1])  {
        console.log('Select Date range');
        this.showAlert(this.$t('Select Date range'));
        return false;
      }
      const [startDatetime, endDatetime] = this.fbLeadSyncDateTimeRangeFromPicker(
        this.selectedDate
      );
      await axios
        .get(`/api/v1/accounts/${this.accountId}/contacts/contact_sync`, {
          params: {
            datetime: [startDatetime, endDatetime],
          },
          headers: {
            api_access_token: apiAccessToken,
          },
        })
        .then(response => {
          if (response.status === 200 || response.status === 204) {
            // Handle the response here
            console.log('Response:', response);
            this.showAlert(this.$t('Lead is synicing in background'));
            this.onClose();
            // Close the response
            return;
          } else {
            // Handle other status codes if needed
            console.error('Unexpected status code:', response.status);
          }
        })
        .catch(error => {
          // Handle errors
          console.error('Error:', error);
        });
    },

      highlightToday(date) {
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear()
      ? 'highlight-today'
      : '';
      },
       disableFutureDates(date) {
    const today = new Date();
    // Set the time to 00:00:00 for accurate comparison
    today.setHours(0, 0, 0, 0);
    return date > today;
  },
  async fetchBoards() {
    try {
      await this.$store.dispatch('boards/get');
      this.boards = this.$store.getters['boards/getBoards'];
    } catch (error) {
      console.error('Error fetching boards:', error);
      // Fallback to direct API call if store doesn't work
      try {
        const response = await this.$http.get(`/api/v1/accounts/${this.accountId}/boards`);
        if (response.data && response.data.boards_data) {
          this.boards = response.data.boards_data;
        }
      } catch (apiError) {
        console.error('Error fetching boards via API:', apiError);
      }
    }
  },
  async fetchPipelineStatuses() {
    if (!this.selectedBoard) {
      this.pipelineStatuses = [];
      this.selectedPipelineStatus = '';
      return;
    }
    try {
      const selectedBoardData = this.boards.find(board => board.id === this.selectedBoard);
      if (selectedBoardData && selectedBoardData.statuses_attributes) {
        this.pipelineStatuses = selectedBoardData.statuses_attributes;
      } else {
        // Fallback: fetch board details if statuses not included
        const response = await this.$http.get(`/api/v1/accounts/${this.accountId}/boards/${this.selectedBoard}`);
        if (response.data && response.data.board_data && response.data.board_data.statuses) {
          this.pipelineStatuses = response.data.board_data.statuses;
        }
      }
      this.selectedPipelineStatus = '';
    } catch (error) {
      console.error('Error fetching pipeline statuses:', error);
      this.pipelineStatuses = [];
    }
  },
  handleMacroClick() {
    if (!this.selectedInbox) {
      this.showAlert(this.$t('Please select an inbox first'));
    }
  },
  },
};
</script>

<style scoped>
.custon_tab {
  display: inline-block;
  width: 49%;
  cursor: pointer;
  padding: 11px;
  font-weight: 600;
  margin: 1px;
}
.assign-title{
  padding-bottom: 16px;
}
.data-change{
  background-color: #40518a !important;
}

.highlight-today {
  background-color: #ffe58f !important;
  border-radius: 50%;
  font-weight: bold;
}
::v-deep .multiselect__content {
  max-height: 70px; 
  overflow-y: auto;
}

::v-deep .multiselect__option:not(.multiselect__option--selected)::after {
  content: none !important;
}

::v-deep .multiselect__input {
  background-color: transparent !important;
}
::v-deep .multiselect__placeholder {
  margin-left: -3px;
}

.info-icon-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: 20px;
  top: -8px;
  width: 280px;
  background-color: #1f2937;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  padding: 8px 12px;
  border-radius: 6px;
  z-index: 1000;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  line-height: 1.4;
}

.info-icon-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.tooltip::before {
  content: '';
  position: absolute;
  left: -6px;
  top: 12px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent #1f2937 transparent transparent;
}
</style>
